module.exports = __webpack_public_path__ + "img/visa.83b2991b.svg";